import React, { useState, useEffect, useRef } from 'react';
import './classlist.css';
import axios from "axios";
import { Link } from 'react-router-dom';
import moment from 'moment';
               
function Classlistpagenw() {
    const [localData,  setlocalData] = useState([]);
    const [updatemessage,  setUpdatemessage] = useState("");
    const[checkrole, setCheckrole] = useState(false);
    const[checkgrade, setCheckgrade] = useState(false);
    const[checkname, setCheckname] = useState(false);
    const[searchterm, setSearchterm] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [addPopup, setaddPopup] = useState(false);
    const [addPopupmessage, setaddPopupmessage] = useState(false);
    const [deletePopup, setdeletePopup] = useState(false);

    const [processingPopup, setprocessingPopup] = useState(false);
    const [processingmessage, setprocessingmessage] = useState("");
    const [processingcontrol, setprocessingcontrol] = useState(false);

    const [addmbrmessage, setAdmbrmessage] = useState('');
    const [items, setItems] = useState([]);
    const [grades, setGrades] = useState([]);
    const [teachnames, setTeachnames] = useState([]);

    /*------------------------------dynamic const working---------------------------*/
    const [isOpen, setIsOpen] = useState(true);
    const [isOpentwo, setIsOpentwo] = useState(true);
    const [isOpenthree, setIsOpenthree] = useState(true);
    const [studentData,  setstudentData] = useState([]);
    const optionsRef = useRef(null);
    const optionstwoRef = useRef(null);
    const optionsthreeRef = useRef(null);
    const [gradeData,  setgradeData] = useState([]);



    const loc = window.location;
    const baseUrl = `${loc.protocol}//${loc.hostname}${loc.hostname === 'localhost' ? ':5000' : ''}`;
    const dynamicsearchmember = '/filterreportdetails';
    const searchmembersurl = baseUrl + dynamicsearchmember;

    const dynamicgetmember = '/getclasslist';
    const getmemberurl = baseUrl + dynamicgetmember;

    const dynamiceditmember = '/editclasslist';
    const editmemberurl = baseUrl + dynamiceditmember;

    const dynamicaddmember = '/addclasslist';
    const addmemberurl = baseUrl + dynamicaddmember;

    const dynamicchangepassword = '/changepassword';
    const changepasswordurl = baseUrl + dynamicchangepassword;

    const dynamicdeletemember = '/deletemember';
    const deletememberurl = baseUrl + dynamicdeletemember;


    /*--------------------------------------working routes----------------------------------------------------*/
    const dynamicsearchmemberall = '/searchmembers';
    const searchmembersallurl = baseUrl + dynamicsearchmemberall; 

    const dynamicsearchclasslist = '/searchclasslist';
    const searchclasslisturl = baseUrl + dynamicsearchclasslist;  

    const dynamicdownloadclasslist = '/downloadclasslist';
    const searchdownloadclasslisturl = baseUrl + dynamicdownloadclasslist;  

    const dynamicmovestudentclass = '/movestudentclass';
    const movestudentclassurl = baseUrl + dynamicmovestudentclass; 



    //const[editcheck, seteditcheck] = useState("off"); /movestudentclass
    

    const [memberDetails, setmemberDetails] = useState({
        userole: "",
        username: "",
        names: "",
        surname: "",
        dob: "",
        Grade: "",
        GradeClass: "",
        gender: "",
        year: null,
        term: "",
        GName: "",
        GPhoneNum: "",
        Email : "",
        Department: "",
        Position: "",
        Address: "",
        PhoneNum: "",
        memberid: "",
        password: "",
        ca: "",
        ra: "",
        testdate: "",
        editcheck: "off"
    });

    const [reportDetails, setReportDetails] = useState({
        _id: "",
        section: "",
        subject: "",
        year: "",
        term: "",
        teacher: "",
        grades:"",
        editcheck: "off"
    });

    const [classlistDetails, setClasslistDetails] = useState({
        memberId: "",
        studentname: "",
        gradeclass: "",
        currentgrade: "",
        totalstudents:"", 
        totalfemales: "", 
        totalmales: "",
        editcheck: "off"
    });

    const [getmembers, setgetmembers] = useState({
        userole: "student"
    });

    const [filterby, setfilterby] = useState("");


    /*useEffect(() => {
      
        //console.log("clicked option seeeeeeeeeeeeeent", location.state.data.quiznum )
        
          const fetchContents = async () => {
            //await dispatch(getOutlines(parsedObj));
            await fetch(getmemberurl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ getmembers })
            })
              .then(response => response.json())
              .then(data => {
                console.log("data contents db",data)
                setlocalData(data);
      
                //setContentData(data);
                
              
            });
            
          };
      
          fetchContents();
      
         
           
      
    }, []);

    console.log("localdata after db out",localData)*/

    

    function handlegradechange(e) {
        setCheckgrade(!checkgrade)
        setCheckname(false)
        setCheckrole(false)
        setfilterby("grade")

    }

    function handlenamechange(e) {
        setCheckname(!checkname)
        setCheckgrade(false)
        setCheckrole(false)
        setfilterby("username")
    
    }

    function handlerolechange(e) {
        setCheckrole(!checkrole)
        setCheckgrade(false)
        setCheckname(false)
        setfilterby("role")
    
    }

    function handleSearchSubmit(e) {
        e.preventDefault();
        setprocessingPopup(true);
        setprocessingmessage("Searching");
        setprocessingcontrol(true);

        const fetchContents = async () => {
            //await dispatch(getOutlines(parsedObj));
           
            await fetch(searchmembersurl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ searchterm })
            })
              .then(response => response.json())
              .then(data => {
                if (data.message === "Successful"){
                    setlocalData(data.info);
                    setprocessingmessage("");
                    setprocessingPopup(false);
                    //setContentData(data);
                }else{
                    setprocessingmessage("Failed please check network connection");
                    setprocessingcontrol(false)
                }
            });
            
          };
      
          fetchContents();
    }

    const clear = () => {

        setReportDetails({ ...reportDetails,
            _id: "", 
            section: "",
            subject: "",
            year: "",
            term: "",
            teacher: "",
            grades:"",
            editcheck: "off"
        });
            
        setItems([]);

        setGrades([]);

        setTeachnames([]);
            
            
    }

    function edit (e) {
        e.preventDefault();

        const Editmemberdet = async () => {
            //await dispatch(getOutlines(parsedObj));
            await fetch(editmemberurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ reportDetails, items, grades, teachnames }),
            
            })
            .then(response => response.json())
              .then(data => {
                //console.log("data contents db all here",data)
                console.log("data contents db all password",data)
                setlocalData(data.messdata);
                //setContentData(data);
                
              
            });

            clear();
            
            
        };
    
        Editmemberdet();
       
    }

    function handleAddSubmit(e) {
        e.preventDefault();
       setaddPopup(true);
       setaddPopupmessage('Adding test')
        const Addquestion = async () => {
            //await dispatch(getOutlines(parsedObj));
            await fetch(movestudentclassurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ classlistDetails }),
            
            })
            .then(response => response.json())
              .then(data => {
                setUpdatemessage("uploading successful");
                if (data.message === "Successful"){
                    setlocalData(data.info)
                     //console.log("Class infomation here",data.info);
                    const femaleCount = (data.info).filter(t => t.gender?.toLowerCase() === "female").length;
                    const maleCount = (data.info).filter(t => t.gender?.toLowerCase() === "male").length;

                    setClasslistDetails({...classlistDetails, totalstudents: (data.info).length, totalfemales: femaleCount, totalmales: maleCount, gradeclass: classlistDetails.currentgrade, editcheck: "off"})
                        
                    setaddPopupmessage('Successful')
                    clear();
                }else{
                    setaddPopupmessage('Failed!!! please check network')
                }
            });

            
            
            
        };
    
        Addquestion();
    }

    function openChangepassClick (e) {
        e.preventDefault();
        setShowPopup(true);
    };

    function changepasswordyes () {
        
        const changepyes = async () => {
            //await dispatch(getOutlines(parsedObj));
            await fetch(changepasswordurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ memberDetails }),
            
            });
            

            clear();
            closeChangepassClick();
            
            
        };

        changepyes();

    }
    
    function closeChangepassClick () {
        setShowPopup(false);

    };

    function deletememberyes (e) {
        e.preventDefault();

        const Editmemberdet = async () => {
            //await dispatch(getOutlines(parsedObj));
            await fetch(deletememberurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ memberDetails }),
            
            })
            .then(response => response.json())
              .then(data => {
                //console.log("data contents db all here",data)
                console.log("data contents db all password",data)
                setlocalData(data);
                //setContentData(data);
                
              
            });

            clear();
            
            
        };
    
        Editmemberdet();

        setdeletePopup(false);
       
    }

    
    function closeaddpop () {
        setaddPopup(false);
        clear();

    };

    function opendeleteuserClick (e) {
        e.preventDefault();
        setdeletePopup(true);
    };

    function closedeletepop () {
        setdeletePopup(false);
        clear();

    };

    const removeItem = (idToRemove) => {
        setItems(prevItems => 
          prevItems.filter(item => item.subject !== idToRemove)
        );
    };

    const addItem = (idToAdd) => {
        const usernameExists = items.some(
            user => user.subject.toLowerCase() === idToAdd.toLowerCase()
          );
      
          if (usernameExists) {
            setAdmbrmessage(`Username "${idToAdd}" already exists!`);
            return;
          }

        setItems(prevUsers => [...prevUsers, { subject: idToAdd }]);
        setAdmbrmessage('');
        clearsubject();
    };

    const clearsubject = () => {

        setReportDetails({ ...reportDetails, 
            subject: ""
        });
        
    }

    ////onSubmit={handleAddSubmit}






    const removeGrade = (idToRemove) => {
        setGrades(prevItems => 
          prevItems.filter(item => item.grades !== idToRemove)
        );
    };

    const addGrade = (idToAdd) => {
        const usernameExists = grades.some(
            user => user.grades.toLowerCase() === idToAdd.toLowerCase()
          );
      
          if (usernameExists) {
            setAdmbrmessage(`Username "${idToAdd}" already exists!`);
            return;
          }

        setGrades(prevUsers => [...prevUsers, { grades: idToAdd }]);
        setAdmbrmessage('');
        cleargrades();
    };

    const cleargrades = () => {

        setReportDetails({ ...reportDetails, 
            grades: ""
        });
        
    }



    const removeTeacher = (idToRemove) => {
        setTeachnames(prevItems => 
          prevItems.filter(item => item.teacher !== idToRemove)
        );
    };

    const addTeacher = (idToAdd) => {
        const usernameExists = teachnames.some(
            user => user.teacher.toLowerCase() === idToAdd.toLowerCase()
          );
      
          if (usernameExists) {
            setAdmbrmessage(`Username "${idToAdd}" already exists!`);
            return;
          }

        setTeachnames(prevUsers => [...prevUsers, { teacher: idToAdd }]);
        setAdmbrmessage('');
        clearTeacher();
    };

    const clearTeacher = () => {

        setReportDetails({ ...reportDetails, 
            teacher: ""
        });
        
    }

   

    function closeprocesspop () {
        setprocessingPopup(false);
    };


    /*----------------------------------------------current functions----------------------------------*/
    const handlereceipent = (event) => {
        //setassignDetails({...assignDetails, grouprep: ""})
        //setassignDetails({...assignDetails, receipent: event.target.value})
        //setmemberDetails({...memberDetails, studentName: event.target.value});
        setClasslistDetails({...classlistDetails, studentname: event.target.value})
        setIsOpen(true);

        var filterby = "username";

        var searchterm = event.target.value;
        console.log("search term is",searchterm)
        
       const fetchContents = async () => {
            //await dispatch(getOutlines(parsedObj));
           
            await fetch(searchmembersallurl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ filterby, searchterm })
            })
              .then(response => response.json())
              .then(data => {
                if (data.message === "Successful"){
                    setstudentData(data.info);
                    //setprocessingmessage("");
                    //setprocessingPopup(false);
                    //setContentData(data);
                }else{
                    //setprocessingmessage("Failed please check network connection");
                    //setprocessingcontrol(false)
                }
                
              
            });
            
          };
      
          fetchContents();
       

    };

    const handleOptionClick = (option) => {
        const resultname = option.names + " " + option.surname;
        //////////setmemberDetails({...memberDetails, term: option.term, memberId: option.memberId, grade: option.gradeclass, studentName: resultname, studentnameonly: option.names , surname: option.surname })
        setClasslistDetails({...classlistDetails, studentname: resultname, currentgrade: option.gradeclass, memberId: option.memberId})
        //setSelectedResult(resultname);
        //setassignDetails({...assignDetails, receipent: resultname, cellnumber: option.cellnumber})
        setIsOpen(false); // Close the dropdown after selecting an option
    };

    const handlereceipentgrade = (event) => {
        //setassignDetails({...assignDetails, grouprep: ""})
        //setassignDetails({...assignDetails, receipent: event.target.value})
        //setmemberDetails({...memberDetails, studentName: event.target.value});
        setClasslistDetails({...classlistDetails, currentgrade: event.target.value})
        setIsOpentwo(true);

        var filterby = "username";

        var searchterm = event.target.value;
        console.log("search term is",searchterm)
        
       const fetchContents = async () => {
            //await dispatch(getOutlines(parsedObj));
           
            await fetch(searchclasslisturl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({searchterm})
            })
              .then(response => response.json())
              .then(data => {
                //console.log("data contents db",data.info.classes)
                if (data.info === null){
                    setgradeData([]);
                }else{
                    setgradeData(data.info.classes);
                }
                
      
                
              
            });
            
          };
      
          fetchContents();
       

    };

    const handleOptiontwoClick = (option) => {
        const resultname = option.names + " " + option.surname;
       
        setClasslistDetails({...classlistDetails, currentgrade: option.grades})
       
        setIsOpentwo(false); // Close the dropdown after selecting an option
    };

    ///---------------------------------------------------Third option Ref-----------------------------------------\\\\\

    const handlegradeclass = (event) => {
        //setassignDetails({...assignDetails, grouprep: ""})
        //setassignDetails({...assignDetails, receipent: event.target.value})
        //setmemberDetails({...memberDetails, studentName: event.target.value});
        setClasslistDetails({...classlistDetails,  gradeclass: event.target.value})
        setIsOpenthree(true);

        var filterby = "username";

        var searchterm = event.target.value;
        console.log("search term is",searchterm)
        
       const fetchContents = async () => {
            //await dispatch(getOutlines(parsedObj));
           
            await fetch(searchclasslisturl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({searchterm})
            })
              .then(response => response.json())
              .then(data => {
                
                if (data.info === null){
                    setgradeData([]);
                }else{
                    console.log("data contents db",data.info.classes)
                    setgradeData(data.info.classes);
                }
                
      
                
              
            });
            
          };
      
          fetchContents();
       

    };

    const handlegradeclassClick = (option) => {
        /////const resultname = option.names + " " + option.surname;
        var filterby = "grade";
        const searchterm = option.grades;
       
        ///setClasslistDetails({...classlistDetails, gradeclass: option.grades})
       
        setIsOpenthree(false); // Close the dropdown after selecting an option

        const fetchContents = async () => {
            //await dispatch(getOutlines(parsedObj));
                   
            await fetch(searchmembersallurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({searchterm, filterby })
            })
            .then(response => response.json())
            .then(data => {
                        

                setlocalData(data.info);
                        

                console.log("Class infomation here",data.info);
                const femaleCount = (data.info).filter(t => t.gender?.toLowerCase() === "female").length;
                const maleCount = (data.info).filter(t => t.gender?.toLowerCase() === "male").length;

                setClasslistDetails({...classlistDetails, totalstudents: (data.info).length, totalfemales: femaleCount, totalmales: maleCount, gradeclass: option.grades, editcheck: "off"})
                        
                        
            
                //setContentData(data);
                        
                    
            });
                    
        };
        
        fetchContents();



    };


    const downloadExcel = async (sortedData) => {
        try {
            const response = await axios.post(
                searchdownloadclasslisturl,
                sortedData,
                { responseType: "blob" }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", "students.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            console.error("Download failed", error);
        }
    };

    


    if (localData !== null) {

       

        /*
        <div className='libdetgradeaddmbrrepolist'>
                        <p>{post.gradeclass}</p>
                    </div>
                    <div className='libdetuseridaddmbrrepolist'>
                        <p>{post.memberId}</p>
                    </div>
                    <div className='libdetpasswordaddmbrrepolist'>
                        <p>{post.role}</p>
                    </div>


                    <div className='liblblgradeaddmbrrepolist'>
                                <p>Grade</p>
                            </div>
                            <div className='liblbluseridaddmbrrepolist'>
                                <p>UserId</p>
                            </div>
                            <div className='liblblpasswordaddmbrrepolist'>
                                <p>Role</p>
                            </div>



        */

        const sortedData = localData.sort((a, b) => {
        const genderA = (a.gender || '').toLowerCase();
        const genderB = (b.gender || '').toLowerCase();

        if (genderA !== genderB) {
            if (genderA === 'female') return -1;
            if (genderB === 'female') return 1;
        }

        return (a.surname || '').trim().localeCompare((b.surname || '').trim());
        });                    

         const userscardtable = sortedData.map((post, index) => (
                <tr
                className='trlvhis'
                key={post._id}
                onClick={() => {
                    setReportDetails({
                        ...reportDetails,
                        id: post._id, 
                        schoolname: post.schoolname,
                        year: post.year,
                        term: post.term,
                        editcheck: "on"
                    });

                   
                    setGrades(post.classes)
                   
                }}
                style={{ cursor: 'pointer' }}
                >
                <td className='tdlvhis'>{index + 1}</td>
                <td className='tdlvhis'>{(post.surname)}</td>
                <td className='tdlvhis'>{(post.names)}</td>
                <td className='tdlvhis'>{(post.gender)}</td>
                <td className='tdlvhis'>{(post.gradeclass)}</td>
                
                </tr>
        ))
        




    return (
        <>
        <div className="addlibmemberpageaddmbrrepolist">
            <div className="addlibmembersectaddmbrrepolist">
                <div className="addlibmemberboxaddmbrrepolist">
                    {processingPopup && (
                        <div className="popuprepolist">
                            <div className="popup-contentrepolist">
                                {processingcontrol ?
                                    <p>{processingmessage}</p>
                                :
                                <>
                                    <p>{processingmessage}</p>
                                    <button className="deletebuttononlbk" onClick={closeprocesspop}>Okay</button>
                                
                                </>
                                }
                            </div>
                        </div>
                    )}
                    {showPopup && (
                        <div className="popuprepolist">
                        <div className="popup-contentrepolist">
                            <p>Are you sure you want to change password!</p>
                            <button className="yesbuttonrepolist" onClick={changepasswordyes}>Yes</button>
                            <button className="nobuttonrepolist" onClick={closeChangepassClick}>No</button>
                        </div>
                        </div>
                    )}
                    {addPopup && (
                        <div className="popuprepolist">
                        <div className="popup-contentrepolist">
                            { updatemessage ?
                            <p>{updatemessage}</p>
                            :
                            <p>Uploading...</p>
                            }
                            { addPopupmessage !== 'Adding test' &&
                                <button className="yesbuttonrepolist" onClick={closeaddpop}>Done</button>
                            }
                        </div>
                        </div>
                    )}
                    {deletePopup && (
                        <div className="popuprepolist">
                        <div className="popup-contentrepolist">
                            <p>Are sure you want to delete this user!</p>
                            <button className="yesbuttonrepolist" onClick={deletememberyes}>Yes</button>
                            <button className="nobuttonrepolist" onClick={closedeletepop}>No</button>
                        </div>
                        </div>
                    )}
                    <h2>Edit Class List</h2>
                    <div className='addlibmembertextboxaddmbrrepolist'>
                        
                            <div className="libuserdetailsrepolist">
                                <div className='classliststudentcont'>
                                    <p className='groupno'>Student Name</p>
                                    <input type="text" className="libusersurnamesaddmbrrepolist" name="libusernames" placeholder='Student Name' value={classlistDetails.studentname} onChange={handlereceipent} autoComplete="off" />
                                    {(isOpen && classlistDetails.studentname !== "") && (
                                        <div className="schedtoinputlistboxenq" ref={optionsRef}>
                                            {studentData.map((result, index) => (
                                            <p className='schedtoinputlistenq' key={index} onClick={() => handleOptionClick(result)}>{result.names + " " + result.surname + " " + result.gradeclass}</p>
                                            ))}
                                        </div>                      
                                    )}
                                </div>

                                <div className='classliststudentcont'>
                                    <p className='groupno'>Current Class</p>
                                    <input type="text" className="libusersurnamesaddmbrrepolist" name="libusernames" placeholder='Current Class' value={classlistDetails.currentgrade} onChange={handlereceipentgrade} autoComplete="off" />
                                    {(isOpentwo && classlistDetails.currentgrade !== "") && (
                                        <div className="schedtoinputlistboxenq" ref={optionstwoRef}>
                                            {gradeData.map((result, index) => (
                                            <p className='schedtoinputlistenq' key={index} onClick={() => handleOptiontwoClick(result)}>{result.grades}</p>
                                            ))}
                                        </div>                      
                                    )}
                                </div>    
                                

                                {(reportDetails.editcheck === "offy" && localData.length === 0)?
                                <>
                                <button className='addbtnaddmbrrepolist' onClick={handleAddSubmit}>Add Class</button>
                                <button className='addbtnaddmbrrepolist' onClick={handleAddSubmit}>Submit All</button>
                                <button className='editbtnaddmbrrepolist' onClick={edit}>Edit</button>
                                </>
                                :(classlistDetails.studentname !== "" && classlistDetails.currentgrade !== "")?
                                <>
                                <button className='addbtnaddmbrrepolist' onClick={handleAddSubmit}>Add To Class</button>
                                <button className='clearbtnaddmbrrepolist' onClick={clear}>Clear</button>
                                
                                </>
                                :
                                <></>
                                }

                               
                            </div>
                        
                    </div>

                </div>
            </div>
             
            <div className="viewlibmembersectaddmbrcardlvhis">
                
                <div className="table-containerlvhis">
                    <h2 className='tabletitlelvhis'>Class List</h2>
                    <div className='currentclasscont'>
                        <div className='classliststudentcont'>
                            <p className='groupno'>Class</p>
                            <input type="text" className="libusersurnamesaddmbrrepolist" name="libusernames" placeholder='Current Class' value={classlistDetails.gradeclass} onChange={handlegradeclass} autoComplete="off" />
                            {(isOpenthree && classlistDetails.gradeclass !== "") && (
                                 <div className="schedtoinputlistboxenqtwo" ref={optionsthreeRef}>
                                    {gradeData.map((result, index) => (
                                    <p className='schedtoinputlistenqtwo' key={index} onClick={() => handlegradeclassClick(result)}>{result.grades}</p>
                                    ))}
                                </div>                      
                            )}
                        </div>   
                    </div>
                    
                    <table className='tablelvhis'>
                        <thead className='theadlvhis'>
                            <tr className='trlvhis'>
                                <th className='thlvhis'>No</th>
                                <th className='thlvhis'>Surname</th>
                                <th className='thlvhis'>Name</th>
                                <th className='thlvhis'>Gender</th>
                                <th className='thlvhis'>Class</th> 
                            </tr>
                        </thead>
                        
                        <tbody className='tbodylvhis'>
                            {userscardtable}
                        </tbody>
                    </table>
                     <div className='classinfocont'>
                        <p className='classinfop'>Class: {classlistDetails.gradeclass}</p>
                        <p className='classinfop'>Female: {classlistDetails.totalfemales}</p>
                        <p className='classinfop'>Male: {classlistDetails.totalmales}</p>
                        <p className='classinfop'>Class total: {classlistDetails.totalstudents}</p>
                    </div>
                    <button
                        className='classlistdownloadbtn'
                        onClick={() => downloadExcel(sortedData)}
                        style={{
                            padding: "10px 20px",
                            marginBottom: "10px",
                            cursor: "pointer"
                        }}
                    >
                        Download Excel
                    </button>
                </div>
                
            </div>
        </div>
        </>
    );
    }
}
        
        
export default Classlistpagenw;

/*
<div className="filterosectaddmbrtestrlvdy">
                    <h2>Filter by:</h2>
                    <div className="filterboxaddmbrtestrlvdy">
                        <div className='form-groupaddmbrtestrlvdy'>
                            <span>Year:</span>
                            <input className='byroletestrlvdy' name="byrole" checked={true} type="checkbox" />
                        </div> 
                        <div className='searchboxaddmbrtestrlvdy'>
                            <input type="text" name="search" onChange={(e) => setSearchterm(e.target.value)} />
                            <button onClick={handleSearchSubmit}>Search</button>
                        </div>
                    </div>
                </div>*/
        